import { ContainerModule, interfaces } from "inversify";
import {
    Client,
    ClientOptions,
    ClientProvider,
    clientRTTI,
    clientProviderRTTI,
    clientOptionsRTTI
} from "~/modules/client";
import { ClientImpl } from "./Client/ClientImpl/ClientImpl";
import { createClient } from "./ClientProvider/createClient";
import { ClientOptionsStore } from "./ClientOptions/ClientOptionsStore";
import { DeepPartial } from "~/utils/DeepPartial";

export const clientModuleContainer = new ContainerModule((bind: interfaces.Bind) => {
    bind<ClientOptions>(clientOptionsRTTI).to(ClientOptionsStore).inSingletonScope();

    bind<Client>(clientRTTI).to(ClientImpl).inSingletonScope();
    bind<ClientProvider>(clientProviderRTTI).toProvider<Client>((context: interfaces.Context) => {
        return (token: string, userOptions?: DeepPartial<ClientOptions>) => {
            return createClient(context.container, token, userOptions);
        };
    });
});
